module.exports = __webpack_public_path__ + "static/hyperv_48.2e300600.png";